import { render, staticRenderFns } from "./general-fields-panel.vue?vue&type=template&id=529b1182&scoped=true&"
import script from "./general-fields-panel.vue?vue&type=script&lang=js&"
export * from "./general-fields-panel.vue?vue&type=script&lang=js&"
import style0 from "./general-fields-panel.vue?vue&type=style&index=0&id=529b1182&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529b1182",
  null
  
)

export default component.exports